import { CaseResponse, CaseSearch } from '../../case/model';

import { AgendaResponse } from '../../details/agenda/model';
import api from './api';

const casesUrl = '/cases';

export function getCases(caseSearch: CaseSearch, offset: number) {
  return api.post(casesUrl,
    {
      offset: offset,
      sortColumn: caseSearch.sortColumn,
      sortDirection: caseSearch.sortDirection,
      fetchSize: caseSearch.fetchSize,
      caseCode: caseSearch.caseCode,
      taskType: caseSearch.taskType,
      archived: caseSearch.archived,
      agendaRef: caseSearch.agendaRef,
      policyHolder: caseSearch.policyHolder,
      hasDocumentForApproval: caseSearch.hasDocumentForApproval,
      hasUnassignedUser: caseSearch.hasUnassignedUser,
      hasMissingHonoraryNote: caseSearch.hasMissingHonoraryNote,
      belongsToPartyId: caseSearch.selectedPartyId,
      belongsToChildPartyId: caseSearch.selectedChildPartyId,
      assignedToPartyId: caseSearch.assignedToPartyId,
      inProgressOnly: caseSearch.inProgressOnly,
    }
  );
}

export function getCaseForMobile(searchCase: string) {
  return api.get(`${casesUrl}/get-case-by-code/${searchCase}`);
}

export function getCasesCount() {
  return api.get(`${casesUrl}/count`);
}

export function getCaseTypeCodes() {
  return api.get(`${casesUrl}/typecodes`);
}

export function getInsuredPerson(caseCode: string) {
  return api.get(`${casesUrl}/insured/${caseCode}`).catch(err => {
    return err;
  });
}

export function getPolicyViewModel(caseCode: string) {
  return api.get(`${casesUrl}/policy-view/${caseCode}`);
}

export function getCaseView(instructionId: number) {
  return api.get(`${casesUrl}/case-view/${instructionId}`).catch(err => {
    console.error(err);
    return err;
  });
}

export function getAgenda(instructionId: number) {
  return api.get(`${casesUrl}/agenda/${instructionId}`).catch(err => {
    console.error(err);
    return err;
  });
}

export function saveAgenda(instructionId: number, data: AgendaResponse) {
  return api.post(`${casesUrl}/agenda`, { instructionId: instructionId, data: data }).catch(err => {
    console.error(err);
    return err;
  });
}

export function useAgendaFromHistory(agendaHistoryAuditId: number) {
  return api.post(`${casesUrl}/agenda-from-history`, { agendaHistoryAuditId: agendaHistoryAuditId }).catch(err => {
    console.error(err);
    return err;
  });
}

export function refuseCase(selectedCase: CaseResponse) {
  return api.post(`${casesUrl}/refuse-case`, {
    selectedCase: selectedCase
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function archiveCase(selectedCase: CaseResponse): Promise<any> {
  return api.post(`${casesUrl}/archive-case`, {
    selectedCase: selectedCase
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function dearchiveCase(selectedCase: CaseResponse): Promise<any> {
  return api.post(`${casesUrl}/dearchive-case`, {
    selectedCase: selectedCase
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function markCaseAsRead(selectedCase: CaseResponse) {
  return api.post(`${casesUrl}/mark-read-case`, {
    selectedCase: selectedCase
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function setInProgressState(selectedCase: CaseResponse) {
  return api.post(`${casesUrl}/in-progress`, {
    selectedCase: selectedCase
  }).catch(err => {
    console.error(err);
    return err;
  });
}
